window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};

/**
 *  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *  Currently not part of the packaged lp transporter - only used by LE2 for now
 *  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

lpTag.taglets.fileupload = lpTag.taglets.fileupload || (function (window) {//Pass in the window so it's a local variable in the scope

        var _version = "0.0.2",
        _transportType = "fileupload",
        _defaults = { //Can be configured with the configure public method
            iFrameDelayLoad: 0,
            iFrameLoadTimeout: 10000,
            messageTimeout: 5000,
            frameTitle: "file upload", //can be overriden with the options passed to displayUpload
            authTokenUrlParName: "authorization", //can be overriden with the options passed to displayUpload
            uploadExtensions: "*.*",   //can be overriden with the options passed to displayUpload
            uploadAutoStart: true,     //can be overriden with the options passed to displayUpload
            uploadTimeout: 120000,    //can be overriden with the options passed to displayUpload
            uploadFrameDebug: false   //can be overriden with the options passed to displayUpload
        },
        _docSubDomain,
        _iframes = {},
        _domains = {},
        _handlers = {},
        _selectorRgx = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,//stole from jquery, to be used to quicken selector if simple class/id/tag selector used
        _msgFailedToInitialize = {message: "failed to initialize upload iframe"},
        _msgTimeout = {message: "message handling timed out"},
        _mandatoryPars = ["success", "url", "frameContainer"],
        _clientCallbacks = ["onFileSelectionChange", "onUploadStart", "onUploadComplete"],
        _logType = { ERROR: "ERROR", DEBUG: "DEBUG", INFO: "INFO" },
        _iframe_state = {VALIDATED: "valid", PENDING: "pending", FAILED: "failed", NOT_FOUND: "notFound"},
        _responseType = {
            SUCCESS: "success",
            ERROR: "error",
            UPLOAD_START: "uploadStart",
            UPLOAD_COMPLETE: "uploadComplete",
            FILE_SELECTED: "fileSelected"};

    /*---------------------------------------------------------------------------------
     Public
     ---------------------------------------------------------------------------------*/
    /**
     * Sets the default configuration we want to use for requests,
     * can be overridden on a request basis
     * properties: callback, encoding, timeout , retries
     * @param configurationObj
     */
    function configure(configurationObj) {
        if (configurationObj) {
            for (var key in configurationObj) {
                if (_defaults.hasOwnProperty(key) && configurationObj.hasOwnProperty(key)) {
                    _defaults[key] = configurationObj[key];
                }
            }
        }
    }

    /**
     * Initializes a new upload client using provided options
     * @param options hash of:
     *              String url
     *              String uploadUrl
     *              String frameContainer
     *              String token (optional)
     *              String authTokenUrlParName (optional, default = "authorization")
     *              String frameClassName (optional, for the iframe)
     *              String uploadExtensions (optional - array or comma separated values: ".png,.jpg,.gif"),
     *              Boolean uploadAutoStart (optional)
     *              Number delayLoad (optional)
     *              Object context (optional)
     *              Number timeout (optional)
     *              Number uploadTimeout (optional, default = 120000)
     *              Boolean uploadFrameDebug (optional, default = false)
     *
     * @returns a reference to the upload client
     */
    function displayUpload(options) {

        var client;

        if (_validateRequest(options)) {
            client = _createUploadIFrameClient(options);
        }
        else {
            _log("request obj is invalid", "displayUpload", _logType.ERROR);
            _runCallback(options.error, {message: "request object is invalid, check mandatory properties"}, options.context);
        }

        return client;
    }

    /*---------------------------------------------------------------------------------
     Public - END
     ---------------------------------------------------------------------------------*/

    /*---------------------------------------------------------------------------------
     Set up
     ---------------------------------------------------------------------------------*/
    function _init() {

        _docSubDomain = _getDomainFromUrl(document.location.href);

        _bindEvent(window, "message", _handleMessage);

        if (lpTag && lpTag.taglets && lpTag.taglets.lpAjax) {
            try {
                lpTag.taglets.lpAjax.addTransport(_transportType, publicAPI);
            }
            catch (exc) {
            }
        }
    }

    /**
     * validates the information to ensure the minimum info is supplied
     * @param obj the options object received from the client of this transport
     * @returns {boolean}
     * @private
     */
    function _validateRequest(obj) {
        var isValid = false;

        if (obj) {
            isValid = true;

            for (var i = 0; i < _mandatoryPars.length; i++) {
                var prop = obj[_mandatoryPars[i]];

                if (typeof prop === "undefined" || prop === null) {
                    isValid = false;
                    break;
                }
            }
        }

        return isValid;
    }

    /**
     * initiates the iframe set up to the domain where the upload will happen
     * returns a client object thats handed back to the calling app
     * @param options
     * @returns {*}
     * @private
     */
    function _createUploadIFrameClient(options) {

        var id = _createUId("fu");

        var frameConfig = _cloneObj(options, true); //clone with data and functions (success, error...)
        var domain = _getDomainFromUrl(options.url);

        frameConfig.id = id;
        frameConfig.frame = _createIFrame(id, options);
        frameConfig.domain = domain;
        frameConfig.uploadExtensions = _getUploadExtensions(options); //can be passed in options or as default
        frameConfig.delayLoad = isNaN(frameConfig.iFrameDelayLoad) ? _defaults.iFrameDelayLoad : frameConfig.iFrameDelayLoad; //can be passed in options or as default
        frameConfig.uploadAutoStart = (typeof frameConfig.uploadAutoStart === "boolean" ? frameConfig.uploadAutoStart : _defaults.uploadAutoStart);
        frameConfig.state = _iframe_state.PENDING;
        frameConfig.fileSelected = false;

        _domains[domain] = (_domains[domain] && !isNaN(_domains[domain]) ? _domains[domain] + 1 : 1);
        _iframes[id] = frameConfig;

        var client = _createUploadClient(id);

        frameConfig.client = client;

        setTimeout(function () {//Always timed out for best compatibility
            _loadIFrame(id);
        }, frameConfig.delayLoad);

        return client;
    }

    function _getUploadExtensions(options) {

        var extensions = options.uploadExtensions || _defaults.uploadExtensions;

        if (extensions instanceof Array) {
            extensions = extensions.join(",");
        }

        return extensions;
    }

    /**
     * creates the upload client that will returned to the calling app
     * the client has methods to start the upload and retrieve the state as well as
     * clean up the upload frame from the page
     * @param id
     * @returns {{startUpload: startUpload, getFrameState: getFrameState, isFileSelected: isFileSelected, removeUpload: removeUpload}}
     * @private
     */
    function _createUploadClient(id) {

        var frameConfig = _iframes[id];

        var client = { //this is the upload client handed back to the calling application
            startUpload: function () {

                var frameConfig = _iframes[id];

                if (frameConfig &&
                    frameConfig.state === _iframe_state.VALIDATED &&
                    frameConfig.fileSelected) {

                    _sendIFrameMessage(id, {
                        domain: frameConfig.domain,
                        command: "startUpload",
                        data: {},
                        success: function () {
                            _log("server received start upload command", "client.startUpload");
                        }
                    });
                }
                else {
                    throw new Error("can't start upload - not initialized yet or file not selected");
                }
            },
            getFrameState: function () {
                var frameConfig = _iframes[id];
                return frameConfig ? frameConfig.state : _iframe_state.NOT_FOUND;
            },
            isFileSelected: function () {
                var frameConfig = _iframes[id];
                return frameConfig ? frameConfig.fileSelected : false;
            },
            removeUpload: function () {
                _cleanupIFrame(id);
            },
            changeFormAttributes: function(formAttributes){
                var frameConfig = _iframes[id];
                _sendIFrameMessage(id, {
                    domain: frameConfig.domain,
                    command: "changeFormAttributes",
                    data: formAttributes,
                    success: function () {
                        _log("upload form attributes successfully changed", "client.changeUploadUrl");
                    }
                });
            }
        };

        for (var i = 0; i < _clientCallbacks.length; i++) { //copy over the callbacks to the client if they were passed from the public method

            var cbName = _clientCallbacks[i];

            if (frameConfig[cbName]) {
                client[cbName] = frameConfig[cbName];
                delete frameConfig[cbName];
            }
        }

        frameConfig = null;

        return client;
    }

    /**
     * method to extract the sub domain from any URL
     * @param url
     * @return {String}
     */
    function _getDomainFromUrl(url) {
        var domainRegEx = new RegExp(/(http{1}s{0,1}?:\/\/)([^\/\?]+)(\/?)/ig);
        var matches, domain = null;

        if (url.indexOf("http") === 0) {
            matches = domainRegEx.exec(url);
        } else {//This is a partial url so we assume it's relative, this is mainly nice for tests
            domain = location.protocol + "//" + location.hostname;
        }

        if (matches && matches.length >= 3 && matches[2] !== "") {
            domain = matches[1].toLowerCase() + matches[2].toLowerCase(); // 0 - full match 1- HTTPS 2- domain
        }
        return domain;
    }

    /**
     * sets the ifram's URL and load callback as well as a timeout callback
     * appends the iframe into the container defined by the calling app
     * @param id
     * @private
     */
    function _loadIFrame(id) {

        var frameConfig = _iframes[id];
        var containerElm = _getFrameContainer(frameConfig.frameContainer);
        var frameElm = frameConfig.frame;

        if (containerElm && containerElm.appendChild) {

            frameConfig.loadCallback = _bind(_onIFrameLoad, null, id); //set the load handler
            frameConfig.iFrameLoadTimeoutHandler = setTimeout(_bind(_onIFrameLoadTimeout, null, id), _defaults.iFrameLoadTimeout); //set load timeout handler

            _bindEvent(frameElm, "load", frameConfig.loadCallback);//this listens to the onload event of the iFrame
            _setIFrameLocation(frameElm, frameConfig.url, frameConfig.uploadFrameDebug);   //set the src attribute of the iframe

            containerElm.appendChild(frameElm);
        }
        else {
            _log("wasnt able to find a valid container to append iframe to using provided selector: (" + frameConfig.frameContainer + ")", "_displayFrame", _logType.ERROR);
            _runCallback(frameConfig.error, {message: "container selector is invalid"}, frameConfig.context);
        }
    }

    /**
     * finds the container for the iframe based on the provided selector
     * will shortcut to basic getElementsByClassName or getElementById or getElementsByTagName
     * for simple selectors for others will use querySelector
     * @param selector
     * @returns {*}
     * @private
     */
    function _getFrameContainer(selector) {     //stole logic from jquery

        var match = _selectorRgx.exec(selector),
            doc = window.document,
            res;

        if (match[1]) {   //id selector
            res = doc.getElementById(match[1]);
        }
        else if (match[3]) { //class selector

            if (doc.getElementsByClassName) {
                res = doc.getElementsByClassName(match[3]);
                res = res[0];
            }
            else {//IE8 - no getElementsByClassName :(

                selector = "." + match[3].replace(/^\d/, function (c) {   //will replace the first character if its a number and escape it as hex so it works
                    return "\\" + c.charCodeAt(0).toString(16) + " ";
                });

                res = doc.querySelector(selector);
            }
        }
        else if (match[2]) { //tag selector
            res = doc.getElementsByTagName(match[2]);
            res = res[0];
        }

        if (!res) {
            res = doc.querySelector(selector);
        }

        return res;
    }

    /**
     * registers the callbacks that will be called when a file is chosen, upload start, upload complete are notified about
     * from the iframe's code
     * @param id
     * @private
     */
    function _registerFramePermanentHandlers(id) {

        var uploadStartHandler = _bind(_onUploadStart, null, id);
        _registerMessageHandler({           //register upload start handler
            id: id + "_" + _responseType.UPLOAD_START,
            success: uploadStartHandler,
            error: uploadStartHandler
        });

        var uploadCompleteHandler = _bind(_onUploadComplete, null, id);
        _registerMessageHandler({           //register upload complete handler
            id: id + "_" + _responseType.UPLOAD_COMPLETE,
            success: uploadCompleteHandler,
            error: uploadCompleteHandler
        });

        _registerMessageHandler({          //register file selected handler
            id: id + "_" + _responseType.FILE_SELECTED,
            success: _bind(_onFileSelectionChange, null, id)
        });
    }

    /**
     * the callback for the iframe load timeout
     * @param id
     * @private
     */
    function _onIFrameLoadTimeout(id) {

        _log("loading of iframe took too long!", "_onIFrameLoadTimeout", _logType.ERROR);

        var frameConfig = _iframes[id];

        if (frameConfig && frameConfig.loadCallback) {
            frameConfig.loadCallback({error: "timeout!"}); //pass error so cleanup will be performed since iframe didnt load on time
        }
    }

    /**
     * creates the callback for validation of the added iFrame
     * @param domain - the iFrame domain
     */
    function _onIFrameLoad(id, eventData) {

        var frameConfig = _iframes[id];

        if (frameConfig && frameConfig.iFrameLoadTimeoutHandler) {
            clearTimeout(frameConfig.iFrameLoadTimeoutHandler);
            delete frameConfig.iFrameLoadTimeoutHandler;
        }

        _validateFrame(id, eventData);
    }

    /**
     * Validation method for an iFrame queued when the iframe fires the load event
     * When this event is triggered it queues the validation request from the internal iFrame
     * with a slight delay, this seems the only way to make it work 100% of the time
     * @param domain - the domain of the iFrame
     * @return {Boolean}
     */
    function _validateFrame(id, eventData) {
        _log("onLoad validation called " + id, "_validateFrame");

        var frameConfig = _iframes[id];

        if (frameConfig) {
            frameConfig.state = eventData && eventData.error ? _iframe_state.FAILED : _iframe_state.VALIDATED;

            if (frameConfig.state === _iframe_state.VALIDATED) {
                _initReadyUploadFrame(id);
            }
            else {
                _cleanupIFrame(id);
                _runCallback(frameConfig.error, _cloneObj(_msgFailedToInitialize), frameConfig.context);
            }
        }
    }

    /**
     * Creates an iFrame in memory and sets the default attributes except the actual URL
     * Does not attach to DOM at this point
     * @param id - a passed in ID for easy lookup later
     * @param options
     * @return {Element} - the detached iFrame element
     */
    function _createIFrame(id, options) {

        var frame = document.createElement("IFRAME");

        frame.setAttribute("id", id);
        frame.setAttribute("name", id);
        frame.setAttribute("title", (options.frameTitle || _defaults.frameTitle)); //Adding an empty title at AT&Ts insistence
        frame.setAttribute("scrolling", "no"); // prevent older browsers from showing scrollbars
        frame.setAttribute("frameBorder", "0"); // prevent older browsers from showing border
        frame.setAttribute("seamless", "seamless"); //newer browsers should support seamless property to show iframe without border and without scrollbars

        if (typeof options.frameClassName === "string") {
            frame.setAttribute("class", options.frameClassName);
        }

        frame.style.overflow = "hidden"; // works in conjunction with scrolling="no"

        return frame;
    }

    /**
     * Sets the iFrame location using a cache bust mechanism,
     * making sure the iFrame is actually loaded and not from cache
     * @param element
     * @param src
     */
    function _setIFrameLocation(element, src, debug) {
        src += (src.indexOf("?") > 0 ? "&bust=" : "?bust=");
        src += new Date().getTime();
        src += "&loc=" + location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
        src += debug === true ? "&debug=true" : "";
        _log("Setting iFrame to URL: " + src, "_setIFrameLocation");
        element.setAttribute("src", src);
    }

    /**
     * sends the initialize command and the needed details for an iframe that successfully loaded onto the page
     * @param id
     * @private
     */
    function _initReadyUploadFrame(id) {

        var frameConfig = _iframes[id];

        if (frameConfig) {

            _registerFramePermanentHandlers(id);

            var initMessageSent = _sendIFrameMessage(id, {
                domain: frameConfig.domain,
                command: "initialize",
                data: {
                    authTokenUrlParName: frameConfig.authTokenUrlParName || _defaults.authTokenUrlParName,
                    token: frameConfig.token,
                    uploadUrl: frameConfig.uploadUrl,
                    uploadInputName: frameConfig.uploadInputName,
                    uploadExtensions: frameConfig.uploadExtensions,
                    chooseButtonStyle: frameConfig.chooseButtonStyle,
                    chooseButtonText: frameConfig.chooseButtonText,
                    uploadAutoStart: frameConfig.uploadAutoStart,
                    uploadTimeout: frameConfig.uploadTimeout,
                    nativeStyles: frameConfig.nativeStyles,
                    uploadInputTitle: frameConfig.uploadInputTitle
                },
                success: function () {
                    _runCallback(frameConfig.success, undefined, frameConfig.context);
                },
                error: function (data) {
                    _runCallback(frameConfig.error, data, frameConfig.context);
                    _cleanupIFrame(id); //failed to initialize, cleanup everything
                }
            });

            if (!initMessageSent) {
                _runCallback(frameConfig.error, _cloneObj(_msgFailedToInitialize), frameConfig.context);
            }
        }
    }

    /*---------------------------------------------------------------------------------
     Set up - END
     ---------------------------------------------------------------------------------*/

    /*---------------------------------------------------------------------------------
     EVENTS & MESSAGING
     ---------------------------------------------------------------------------------*/
    /**
     * the callback for post message event
     * @param event
     * @private
     */
    function _handleMessage(event) {
        var result;
        var origin = event.origin;
        if (_domains[origin] && _domains[origin] > 0) {
            try {
                //make sure we're waiting for a message from this iframe
                _log("received message from postmessage: " + event.data, "_handleMessage");
                result = JSON.parse(event.data);
            }
            catch (exc) {
                result = null;
                _log("Error in handling message from frame:" + exc + " origin: " + origin, "_handleMessage", _logType.ERROR);
            }

            if (result && typeof result === "object") {
                _executeMessageCallback(result);
            }
        }
    }

    /**
     * Retrieves and triggers the correct callback for
     * the response we got from the iFrame
     * @param data
     * @return {Boolean}
     */
    function _executeMessageCallback(data) {

        var handled = false;

        if (data.callId) {
            handled = _handleWithMessageHandler(data);
        }
        else {   //message without callid, could be for permanent handler

            handled = _handleWithPermanentHandler(data);
        }

        if (!handled) {
            _log("handler not found for message: " + data, "_executeMessageCallback");
        }
    }

    function _handleWithPermanentHandler(msgData) {

        var callback,
            handled = false,
            permanentId = msgData.parentId + "_" + msgData.type;

        if (_handlers[permanentId]) {

            var handler = _handlers[permanentId];

            if (handler) {
                var handlerData = msgData.data;

                if (handlerData.state === _responseType.SUCCESS) {
                    callback = handler.success;
                }
                else {
                    callback = handler.error;
                }

                handled = true;
                _runCallback(callback, handlerData, null);
            }
        }

        return handled;
    }

    function _handleWithMessageHandler(msgData) {

        var callback,
            handled = false,
            handler = _handlers[msgData.callId];

        if (handler) {

            if (msgData.type === _responseType.SUCCESS) {
                callback = handler.success;
            }
            else {
                callback = handler.error;
            }

            handled = true;

            _runCallback(callback, msgData.data, handler.context);
            _unregisterMessageHandler(msgData.callId);
        }

        return handled;
    }

    /**
     * Sends the actual request to the child frame
     * while setting up callbacks
     * @param msgObj
     * @return {Boolean}
     */
    function _sendIFrameMessage(id, msgObj) {

        var msgStr, msgSent = false;

        msgObj = _setUpMessage(id, msgObj);

        if (msgObj) {
            try {
                msgStr = _stringify(msgObj);
            } catch (err) {
                _log("Error trying to stringify message", "_sendRequest", _logType.ERROR);
                return false;
            }
        }

        _registerMessageHandler({
            id: msgObj.callId,
            success: msgObj.success,
            error: msgObj.error,
            context: msgObj.context,
            timeout: msgObj.timeout});

        try {
            msgSent = _postToIFrame(id, msgObj.domain, msgStr);
        }
        catch (err) {
            _log("Error trying to send message: " + err, "_sendRequestToIFrame", _logType.ERROR);
            msgSent = false;
        }
        return msgSent;
    }

    /**
     * Sets up the call to have a callId we use to identify the returning message
     * Sets up the callback domain
     * Sets up triggering of progress events if a progress callback was supplied
     * @param msgObj
     * @return {*}
     */
    function _setUpMessage(id, msgObj) {

        msgObj = _cloneObj(msgObj, true);

        var frameConfig = _iframes[id];

        if (frameConfig) {
            if (frameConfig.domain === msgObj.domain) {  //make sure the domain of the frame and the domain of the message match

                msgObj.parentId = frameConfig.id;
                msgObj.callId = _createUId("fuCall");
                msgObj.returnDomain = _docSubDomain;
                msgObj.timeout = (msgObj.timeout || _defaults.messageTimeout);

                return msgObj;
            }
        }

        _log("couldnt set up message object, matching iframe not found", "_setUpMessage", _logType.ERROR);
    }

    /**
     * Posts the message to the sub-domain iFrame
     * Increments the counters so we know how many requests were
     * sent to this iFrame
     * @param domain
     * @param msgToSend
     * @return {Boolean}
     */
    function _postToIFrame(id, domain, msgToSend) {

        var messageSent = false;

        try {
            _log("sending msg to domain " + domain, "postTheMessage");
            _iframes[id].frame.contentWindow.postMessage(msgToSend, domain);
            messageSent = true;
        }
        catch (err) {
            _log("Error trying to send message: " + err, "postTheMessage", _logType.ERROR);
        }
        return messageSent;
    }

    /**
     * Queues a callback for when we get responses from the iFrame
     * @param msg
     *      callId - the UID we sent to the iFrame
     *      success - the success method passed in
     *      error - the error method passed in
     *      progress - the progress method passed in
     *      context - the execution context for the callbacks
     *      timeout - the timeout for this request
     */
    function _registerMessageHandler(handler) { //callId, success, error, progress, context, timeout) {

        if (handler.id && _isFunction(handler.success)) {

            var registered = _handlers[handler.id] = {
                success: handler.success,
                error: handler.error,
                context: handler.context
            };

            if (handler.timeout && handler.timeout > 0) { //sub-zero timeout is no timeout
                registered.timeoutHandler = setTimeout(_bind(_onMessageTimeout, null, handler.id), handler.timeout);
            }
        }
    }

    /**
     * callback for when the configured timeout interval has passed for a post message responses
     * @param handlerId
     * @private
     */
    function _onMessageTimeout(handlerId) {

        var handler = _handlers[handlerId];

        if (handler) {
            _log("message with id: " + handlerId + " timed out", "_onMessageTimeout");

            _runCallback(handler.error, _cloneObj(_msgTimeout), handler.context);
            _unregisterMessageHandler(handlerId);
        }
    }

    /*---------------------------------------------------------------------------------
     EVENTS & MESSAGING - END
     ---------------------------------------------------------------------------------*/

    /*---------------------------------------------------------------------------------
     UPLOAD-CLIENT CALLBACKS
     ---------------------------------------------------------------------------------*/
    function _onUploadStart(id, data) {
        _log("upload start called for id: " + id + " with state: " + data.state, "_onUploadStart");

        var frameConfig = _iframes[id];

        if (frameConfig && frameConfig.client) {
            _runCallback(frameConfig.client.onUploadStart, data, null);     //execute callback on client

            if (data.state === _responseType.ERROR) {
                _runCallback(frameConfig.error, data, frameConfig.context); //also execute general error callback
            }
        }
    }

    function _onUploadComplete(id, data) {
        _log("upload complete called for id: " + id, "_onUploadComplete with state: " + data.state);

        var frameConfig = _iframes[id];

        if (frameConfig) {
            if (frameConfig.client) {
                _runCallback(frameConfig.client.onUploadComplete, data, null); //execute callback on client
            }

            if (data.state === _responseType.ERROR) {
                _runCallback(frameConfig.error, data, frameConfig.context); //also execute general error callback
            }
        }
    }

    function _onFileSelectionChange(id, data) {

        _log("file selection change called for id: " + id, "_onFileSelectionChange");
        var frameConfig = _iframes[id];

        if (frameConfig) {

            frameConfig.fileSelected = !!data.file;

            if (frameConfig.client) {
                _runCallback(frameConfig.client.onFileSelectionChange, data, null);  //execute callback on client
            }
        }
    }

    /*---------------------------------------------------------------------------------
     UPLOAD-CLIENT CALLBACKS - END
     ---------------------------------------------------------------------------------*/

    /*---------------------------------------------------------------------------------
     Cleanup
     ---------------------------------------------------------------------------------*/
    /**
     * Cleans up the iFrame for a specific domain
     * @param domain
     */
    function _cleanupIFrame(id) {
        _log("Cleaning up iFrame: " + id, "_cleanupIFrame");

        var frameConfig = _iframes[id];

        if (frameConfig) {
            _unbindEvent(frameConfig.frame, "load", frameConfig.loadCallback); //unbind load event
            _iframes[id] = null;
            delete _iframes[id];
            _unregisterDomain(frameConfig.domain);
            _unregisterFramePermanentHandlers(id);
            frameConfig.frame.parentNode.removeChild(frameConfig.frame); //remove from html
        }
    }

    function _unregisterDomain(domain) {

        if (_domains[domain]) {

            if (_domains[domain] > 1) {
                _domains[domain] -= 1;
            }
            else {
                _domains[domain] = null;
                delete _domains[domain];
            }
        }
    }

    function _unregisterMessageHandler(callId) {

        var handler = _handlers[callId];

        if (handler) {

            if (handler.timeoutHandler) {
                clearTimeout(handler.timeoutHandler);
            }

            _handlers[callId] = null;
            delete _handlers[callId];
        }
    }

    function _unregisterFramePermanentHandlers(id) {
        _unregisterMessageHandler(id + "_" + _responseType.UPLOAD_START);
        _unregisterMessageHandler(id + "_" + _responseType.UPLOAD_COMPLETE);
        _unregisterMessageHandler(id + "_" + _responseType.FILE_SELECTED);
    }

    /*---------------------------------------------------------------------------------
     Cleanup - END
     ---------------------------------------------------------------------------------*/

    /*---------------------------------------------------------------------------------
     Utilities
     ---------------------------------------------------------------------------------*/
    /**
     * Protected method for executing callbacks
     * @param func
     * @param context
     * @param data
     */
    function _runCallback(func, data, context) {
        if (_isFunction(func)) {
            try {
                func.call(context || null, data);
            } catch (err) {
                _log("Error in executing callback: " + err, "_runCallback", _logType.ERROR);
            }
        }
    }

    /**
     * Creates a Unique identifier with a prefix
     * @return {String}
     */
    function _createUId(preFix) {
        return preFix + "_" + Math.floor(Math.random() * new Date().getTime());
    }

    /**
     * Passes a log to lpTag
     * @param msg
     * @param type
     * @param callingObj
     */
    function _log(msg, callingObj, type) {

        type = type || _logType.DEBUG;
        callingObj = callingObj || "method";

        if (window.lpTag && lpTag.log) {
            lpTag.log(msg, type, "[FileUpload." + callingObj + "]");
        }
    }

    /**
     * copies over an object's properties and possibly its methods
     * @param obj
     * @param withFunctions copy also the methods of the objects
     * @returns {{}}
     * @private
     */
    function _cloneObj(obj, withFunctions) {
        var resObj = {};
        if (obj.constructor === Object) {
            for (var key in obj) {
                try {
                    if (obj.hasOwnProperty(key) && (typeof obj[key] !== "function" || withFunctions)) {
                        resObj[key] = obj[key];
                    }
                } catch (exc) {
                    _log("Error creating request object data clone: " + exc, "cloneSimpleObj", _logType.ERROR);
                }
            }
        } else if (obj.constructor === Array) {
            resObj = obj.slice(0) || [];
        } else if (typeof obj !== 'function') {
            resObj = obj;
        }
        return resObj;
    }

    /**
     * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
     * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
     * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
     * The function accepts a value and and uses the native JSON.stringify
     * Can throw an exception (same as JSON.stringify).
     */
    function _stringify(value) {
        var stringified;
        if (typeof Array.prototype.toJSON === 'function') {
            var toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    /**
     * Binding function for DOM elements
     * @param elem - the element we're binding to
     * @param eventName - the event we're listening on
     * @param callback - our callback for when it happens
     */
    function _bindEvent(elem, eventName, callback) {
        if (elem.addEventListener) {
            elem.addEventListener(eventName, callback, false);
        } else {
            elem.attachEvent("on" + eventName, callback);
        }
    }

    /**
     * Unbinds a DOM event
     * @param elem
     * @param eventName
     * @param callback
     */
    function _unbindEvent(elem, eventName, callback) {
        if (elem.removeEventListener) {
            elem.removeEventListener(eventName, callback, false);
        } else if (elem.detachEvent) {
            elem.detachEvent("on" + eventName, callback);
        }
    }

    function _isFunction(fn) {
        return fn && typeof fn === "function";
    }

    /**
     * mimics the native bind function for IE8
     * @param fn
     * @returns {*}
     * @private
     */
    function _bind(fn) {

        var boundFn;

        if (!_isFunction(fn)) {
            throw new TypeError("_bind - cant bind to non-function parameter");
        }

        if (Function.prototype.bind) {  //use native bind
            boundFn = Function.prototype.bind.apply(fn, Array.prototype.slice.call(arguments, 1));
        }
        else {

            var args = Array.prototype.slice.call(arguments, 2);
            var context = arguments[1];

            boundFn = function () {
                fn.apply(context, args.concat(Array.prototype.slice.call(arguments))); //in IE8 no native bind
            };
        }

        return boundFn;
    }

    /*---------------------------------------------------------------------------------
     Utilities - END
     ---------------------------------------------------------------------------------*/

    var publicAPI = {//These are the exposed public methods of this SINGLETON
        configure: configure,
        displayUpload: displayUpload,
        getVersion: function () {
            return _version;
        },
        getName: function () {
            return _transportType;
        }
    };

    _init();

    return publicAPI;
})(window);

if (typeof define === "function" && define.amd) { //make fileupload available as an AMD module
    define(function () {
        return lpTag.taglets.fileupload;
    });
}
